import styled from "styled-components";
import { deviceSizesMin } from "../../../DeviceSizes";

export const SlackContainer = styled.div`
  padding: 0 30px 50px 30px;
  margin-top: 82px;

  @media only screen and ${deviceSizesMin.laptop} {
    width: 1170px;
    margin: 102px auto;
  }
`;

export const SlackHeader = styled.h1`
  text-align: center;
  font-size: 32px;
  margin-bottom: 10px;

  text-transform: uppercase;
`;

export const SlackImageLinkWrapper = styled.a``;

export const SlackImage = styled.img`
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;

  @media only screen and ${deviceSizesMin.laptop} {
    width: 50%;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
`;

export const SlackDescription = styled.p`
  text-align: center;
  font-size: 16px;
`;
